import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "header_wrapper" }
const _hoisted_3 = { class: "ps-6 text-grey-darken-1" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "text-right" }
const _hoisted_6 = { class: "text-right" }
const _hoisted_7 = { class: "text-right font-weight-bold text-h6 py-2" }
const _hoisted_8 = { class: "mt-5 mx-4" }
const _hoisted_9 = {
  key: 0,
  class: "pb-10"
}
const _hoisted_10 = { class: "text-caption mb-1" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "text-caption text-grey-darken-1" }
const _hoisted_13 = { class: "my-3 text-body-2 font-weight-bold" }
const _hoisted_14 = { class: "text-body-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "pa-0"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_toolbar, {
            color: "primary",
            dark: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                onClick: _ctx.routerBack,
                style: {"position":"absolute"},
                icon: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createTextVNode("mdi-chevron-left", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_v_toolbar_title, { style: {"position":"absolute","left":"50%","transform":"translateX(-50%)","margin":"0"} }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.createYearMonth({
                 year: _ctx.selectedInvoice.year,
                 month: _ctx.selectedInvoice.month,
               })), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_v_card, {
          class: "mt-1",
          variant: "flat"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_table, {
              density: "compact",
              class: "invoice-table",
              style: {"margin-top":"8px"}
            }, {
              default: _withCtx(() => [
                _cache[11] || (_cache[11] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", { class: "text-left" }, "項目"),
                    _createElementVNode("th", { class: "text-left" }, "金額"),
                    _createElementVNode("th", { class: "text-left" }, "課税/非課税")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _cache[1] || (_cache[1] = _createElementVNode("td", null, "月極保育料", -1)),
                    _createElementVNode("td", null, " ¥" + _toDisplayString(_ctx.selectedInvoice.monthlyNurseryFee + _ctx.selectedInvoice.monthlyNurseryFeeDiff), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.getIsFeeStr(_ctx.selectedInvoice.hasMonthlyFeeTax)), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[2] || (_cache[2] = _createElementVNode("td", null, "一時保育料", -1)),
                    _createElementVNode("td", null, " ¥" + _toDisplayString(_ctx.selectedInvoice.tempNurseryFee + _ctx.selectedInvoice.tempNurseryFeeDiff), 1),
                    _cache[3] || (_cache[3] = _createElementVNode("td", null, null, -1))
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[4] || (_cache[4] = _createElementVNode("td", null, "月極延長保育料", -1)),
                    _createElementVNode("td", null, " ¥" + _toDisplayString(_ctx.selectedInvoice.monthlyAdditionalFee + _ctx.selectedInvoice.monthlyAdditionalFeeDiff), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.getIsFeeStr(_ctx.selectedInvoice.hasMonthlyAdditionalTax)), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[5] || (_cache[5] = _createElementVNode("td", null, "スポット延長保育料", -1)),
                    _createElementVNode("td", null, " ¥" + _toDisplayString(_ctx.selectedInvoice.spotAdditionalFee + _ctx.selectedInvoice.spotAdditionalFeeDiff), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.getIsFeeStr(_ctx.selectedInvoice.hasSpotAdditionalFeeTax)), 1)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedInvoice.addtionalFeeDetails, (a) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: a.date
                    }, [
                      _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.getDateStr(a.date)) + " " + _toDisplayString(a.durationMin) + "分", 1),
                      _createElementVNode("td", null, _toDisplayString(a.fee), 1),
                      _cache[6] || (_cache[6] = _createElementVNode("td", null, null, -1))
                    ]))
                  }), 128)),
                  (_ctx.hasSpotMaximumLimit)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_4, [...(_cache[7] || (_cache[7] = [
                        _createElementVNode("td", {
                          colspan: "3",
                          class: "text-caption text-error pa-2",
                          style: {"white-space":"normal"}
                        }, " ※ 表示されている各日のスポット延長料金の合計は上限設定額を上回ることがあります。実際のご請求は、設定された上限金額となります。 ", -1)
                      ]))]))
                    : _createCommentVNode("", true),
                  _createElementVNode("tr", null, [
                    _cache[8] || (_cache[8] = _createElementVNode("td", null, "主食・副食料", -1)),
                    _createElementVNode("td", null, " ¥" + _toDisplayString(_ctx.selectedInvoice.foodServiceFee + _ctx.selectedInvoice.foodServiceFeeDiff), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.getIsFeeStr(_ctx.selectedInvoice.hasFoodServiceFeeTax)), 1)
                  ]),
                  _createElementVNode("tr", null, [
                    _cache[9] || (_cache[9] = _createElementVNode("td", null, "先月以前請求額", -1)),
                    _createElementVNode("td", null, "¥" + _toDisplayString(_ctx.selectedInvoice.accountsReceivable), 1),
                    _cache[10] || (_cache[10] = _createElementVNode("td", null, null, -1))
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_card, {
          class: "mt-1",
          variant: "flat"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_table, { density: "compact" }, {
              default: _withCtx(() => [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _cache[12] || (_cache[12] = _createElementVNode("th", { class: "text-left" }, "その他", -1)),
                    _createElementVNode("th", _hoisted_5, " (" + _toDisplayString(_ctx.getIsFeeStr(_ctx.selectedInvoice.hasExtraServiceFeeTax)) + ") ", 1)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedInvoice.extraServiceDetails, (e) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: e.uniqueServiceId
                    }, [
                      _createElementVNode("td", null, _toDisplayString(e.serviceName), 1),
                      _createElementVNode("td", _hoisted_6, _toDisplayString(e.adjustmentAmount + e.fee), 1)
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_card, {
          class: "mt-2",
          variant: "flat",
          border: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_table, { density: "compact" }, {
              default: _withCtx(() => [
                _cache[13] || (_cache[13] = _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", { class: "text-right" }, "合計金額")
                  ])
                ], -1)),
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", _hoisted_7, _toDisplayString(_ctx.selectedInvoice.totalAmount) + "円 ", 1)
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_8, [
          _cache[15] || (_cache[15] = _createElementVNode("p", { class: "mb-3" }, "上記の通りご請求申し上げます。", -1)),
          (!_ctx.isGakken(_ctx.selectedInvoice.transferAccount?.nurseryId))
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("p", _hoisted_10, " お支払い方法：" + _toDisplayString(_ctx.getPaymentCategoryStr(_ctx.selectedInvoice.paymentMethod)), 1),
                (!_ctx.selectedInvoice.paymentMethod || _ctx.selectedInvoice.paymentMethod === 'invoice')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("p", _hoisted_12, " ※前月ご請求額のご入金状況につきましては" + _toDisplayString(_ctx.selectedInvoice.month) + "月25日までのご入金までを反映しています。 ", 1),
                      _createElementVNode("p", _hoisted_13, " 【" + _toDisplayString(_ctx.calcMonth(_ctx.selectedInvoice.month)) + "月25日】までにお子様のお名前で、下記口座へお振込をお願い致します。 ", 1),
                      _createVNode(_component_v_sheet, {
                        rounded: "",
                        class: "pa-4",
                        style: {"border":"3px solid rgba(0, 0, 0, 0.50)"}
                      }, {
                        default: _withCtx(() => [
                          _cache[14] || (_cache[14] = _createElementVNode("p", { class: "text-caption font-weight-bold mb-2" }, "お振込先", -1)),
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("p", null, _toDisplayString(_ctx.selectedInvoice.transferAccount.beneficiaryBank) + " " + _toDisplayString(_ctx.selectedInvoice.transferAccount.branchName), 1),
                            _createElementVNode("p", null, "口座番号：" + _toDisplayString(_ctx.selectedInvoice.transferAccount.accountNumber), 1),
                            _createElementVNode("p", null, "名義：" + _toDisplayString(_ctx.selectedInvoice.transferAccount.accountHolder), 1)
                          ])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _: 1
  }))
}